import { fieldTypesAgGrid } from '../../constants/globals';
import { tableConfig } from '../../constants/tables';
import { formatText } from '../../utils';
import { ActionTypes } from '../Administration/utils';

//Ovde se očekuje da je tableName pripremljen u smislu, naziv je u jednini
export const getModelName = (tableName) =>
  tableName?.replace(tableName[0], tableName[0].toUpperCase()) || '';

export const getTableNameSingular = (tableName) => {
  if (!tableName?.endsWith('s')) return tableName;
  return (
    Object.values(tableConfig)?.find((t) => t.name === tableName)
      ?.singularName || ''
  );
};

export const filterAllowedActions = (actionsSettings, allowedActions) =>
  actionsSettings?.filter(
    (i) => !i?.allowedAction || allowedActions?.includes(i?.allowedAction)
  ) || [];

export const getTranslations = (tableName, tanslations) => {
  const tableNameWithFirstUpperLetter =
    getTableNameWithFirstUpperLetter(tableName);
  return tanslations[`${tableNameWithFirstUpperLetter}Page`];
};

export const getOperationName = (action) => {
  switch (action) {
    case ActionTypes.ACTIVATE2FA:
      return ActionTypes.ACTIVATE.toLowerCase();
    case ActionTypes.DEACTIVATE2FA:
      return ActionTypes.DEACTIVATE.toLowerCase();
    default:
      return action.toLowerCase();
  }
};

export const getConfirmDialogMessageAndAction = (
  action,
  translation,
  tableName,
  data
) => {
  return {
    confirmMessage: getConfirmDialogMessage(
      action,
      translation,
      data,
      tableName
    ),
    confirmAction: getActionName(action, tableName),
  };
};
//TODO Razraditi situaciju kada imamo mix logickih operatora || i &&
export const isActionDisabled = (rowData, disableCriteria) => {
  if (!disableCriteria || disableCriteria.length === 0) return false;
  const isAndCondition = disableCriteria.includes('&&');
  const criteriaArray = disableCriteria.split(/\s*&&\s*|\s*\|\|\s*/);

  let allCriteriaMet = true;
  let anyCriteriaMet = false;

  for (const criteria of criteriaArray) {
    const [key, value] = criteria.split(':');
    if (`${rowData[key]}` === value) {
      if (!isAndCondition) {
        anyCriteriaMet = true;
      }
    } else {
      if (isAndCondition) {
        allCriteriaMet = false;
        break;
      }
    }
  }

  if (isAndCondition) {
    return allCriteriaMet;
  } else {
    return anyCriteriaMet;
  }
};

export const getActionSettings = (
  columnSettingsList,
  allowedActions,
  targetAction
) => {
  const actionColumn = columnSettingsList?.find(
    (c) => c?.type === fieldTypesAgGrid.ACTION
  );

  const actionsSettings = filterAllowedActions(
    actionColumn?.actionsSettings,
    allowedActions
  );

  return actionsSettings?.find((a) => a?.type === targetAction);
};

export const showActionButton = (actionSettings, allowedActions) => {
  return (
    actionSettings &&
    allowedActions?.includes(actionSettings?.allowedAction) &&
    !actionSettings?.hide
  );
};

//Nazivi modala - konvencija
export const getModalTitle = (action, translations, tableName, object) => {
  const additionalInfo =
    object?.name || checkAdditionalTitleInfo(tableName)(object);
  switch (action) {
    case ActionTypes.CREATE:
      return translations?.['modalForAddTitle'];
    case ActionTypes.UPDATE:
      return additionalInfo
        ? `${translations?.['modalForUpdateTitle']} - ${additionalInfo}`
        : translations?.['modalForUpdateTitle'];
    case ActionTypes.PREVIEW:
      return additionalInfo
        ? `${translations?.['modalForPreviewTitle']} - ${additionalInfo}`
        : translations?.['modalForPreviewTitle'];
    case ActionTypes.VERIFY:
      return translations?.['modalForVerificationTitle'];
    case ActionTypes.META_DATA_PREVIEW:
      return translations?.['modalForMetaDataPreviewTitle'];
    case ActionTypes.CONSENT_GIVE:
      return translations?.['modalForConsentTitle'];
    case ActionTypes.PROCESS:
      return translations?.['modalForProcessTitle'];
    case ActionTypes.PROCESS1:
      return translations?.['modalForProcess1Title'];
    case ActionTypes.PROCESS2:
      return translations?.['modalForProcess2Title'];
    case ActionTypes.SHOW_CHILDREN:
      return translations?.['modalForShowChildrenTitle'];
    case ActionTypes.PASSWORD_CHANGE:
      return translations?.['modalForPasswordChangeTitle'];
    default:
      return '';
  }
};

export const getActionName = (action, tableName) => {
  const actionNameStart = action?.toLowerCase();
  const actionNameEnd = getModelName(getTableNameSingular(tableName));
  return `${actionNameStart}${actionNameEnd}`;
};

export const isActionProcess = (action) => {
  return action?.includes('PROCESS');
};

export const getMetaDataTypeTable = (type) => {
  return `${type}MetaData`;
};

export const containsMetaData = (type) => {
  return type?.includes('MetaData');
};

export const checkHasTableMetaData = (tableName) => {
  const matchingTable = Object.values(tableConfig).find(
    (table) => table?.name === tableName
  );
  return !!matchingTable?.hasMetaData;
};

function getConfirmDialogMessage(action, translation, data, tableName) {
  const additionalInfo = checkConfirmDialogAdditionalInfo(tableName);
  switch (action) {
    case ActionTypes.ACTIVATE:
      return additionalInfo
        ? formatText(translation?.activateMessage, data?.name)
        : translation?.activateMessage;
    case ActionTypes.DEACTIVATE:
      return additionalInfo
        ? formatText(translation?.deactivateMessage, data?.name)
        : translation?.deactivateMessage;
    case ActionTypes.ACTIVATE2FA:
      return additionalInfo
        ? formatText(translation?.activateMessage2fa, data?.name)
        : translation?.activateMessage2fa;
    case ActionTypes.DEACTIVATE2FA:
      return additionalInfo
        ? formatText(translation?.deactivate2faMessage, data?.name)
        : translation?.deactivate2faMessage;
    case ActionTypes.DELETE:
      return additionalInfo
        ? formatText(translation?.deleteMessage, data?.name)
        : translation?.deleteMessage;
    case ActionTypes.VERIFY:
      return translation?.verifyMessage || '';
    case ActionTypes.REJECT:
      return translation?.rejectMessage || '';
    default:
      return '';
  }
}

function getTableNameWithFirstUpperLetter(tableName) {
  const tableNameFirstLetter = tableName?.[0] || '';

  return (
    tableName?.replace(
      tableNameFirstLetter,
      tableNameFirstLetter?.toUpperCase()
    ) || ''
  );
}

export const getProcessType = (action, config) => {
  switch (action) {
    case ActionTypes.PROCESS:
      return {
        type: config.processType,
      };
    case ActionTypes.PROCESS1:
      return {
        type: config.processType1,
      };
    case ActionTypes.PROCESS2:
      return {
        type: config.processType2,
      };
    default:
      return null;
  }
};

const getMatchingTable = (tableName) => {
  return Object.values(tableConfig).find((table) => table?.name === tableName);
};

export const checkConsentStatusHandler = (type) => {
  return getMatchingTable(type)?.checkConsentStatus || (() => false);
};

export const checkVerificationStatusHandler = (type) => {
  return getMatchingTable(type)?.checkVerificationStatus || (() => false);
};

export const checkObjectName = (type) => {
  return getMatchingTable(type)?.checkName || (() => false);
};

export const checkConfirmDialogAdditionalInfo = (tableName) => {
  return !!getMatchingTable(tableName)?.confirmDialogAdditionalInfo;
};

export const checkAdditionalTitleInfo = (tableName) => {
  return getMatchingTable(tableName)?.additionalTitleInfo || (() => false);
};
